"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.microEventDispatcher = void 0;
const _1 = require(".");
function microEventDispatcher(event) {
    const microEvent = new CustomEvent(`${_1.EVENT_NAME}-${event.eventName}`, { detail: Object.assign({}, event) });
    window.dispatchEvent(microEvent);
}
exports.microEventDispatcher = microEventDispatcher;
//# sourceMappingURL=dispatcher.js.map